class Top {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){

    // メインビュースライダー
    let mvSlideSpeed = 5000;
    const mvSlider = new Swiper('.js-mv-swiper', {
      slidesPerView: 1.5,
      loop: true,
      speed: mvSlideSpeed,
      allowTouchMove: false,
      spaceBetween: 20,
      autoplay: {
        delay: 0
      },
      breakpoints: {
        851: {
          slidesPerView: 4.5,
          spaceBetween: 20,
        }
      },
      on: {
        imagesReady: function(){
          $('.js-mv-wrapper').removeClass('is-loading');
        }
      }
    });

    window.addEventListener('pageshow', function (event) {
      if (event.persisted) {
        // mvSlider.autoplay.start();
        window.location.reload();
      }
    });

    // NUMBERS下のスライダー
    let numbersSlider = '.js-numbers-swiper';
    new Swiper(numbersSlider, {
      slidesPerView: 2,
      loop: true,
      speed: 8000,
      allowTouchMove: false,
      autoplay: {
        delay: 0
      },
      breakpoints: {
        851: {
          slidesPerView: 3,
        }
      }
    })
  }
}